/* ALLUP-SHOP DS — c-athlete-voices.js
 * 「アスリートの声」スライダーのサムネイル型ナビゲーション同期。
 * <slider-component>(global.js) が prev/next ボタンの横スクロールを担い、
 * このスクリプトは slider の scroll を監視してサムネの is-active を同期し、
 * サムネクリックで対応スライドへスクロールさせる（c-featured-blog-dots.js と同型）。
 *
 * 命名規則: IIFE + data-* 属性駆動（グローバル汚染なし）
 * 対象:     slider-component.c-athlete-voices__slider 内の [data-c-athlete-voices-thumbs]
 * active class: is-active
 */
(function () {
  'use strict';

  var ACTIVE_CLASS = 'is-active';

  function initThumbs(sliderComponent) {
    var slider = sliderComponent.querySelector('[id^="Slider-"]');
    var thumbsWrapper = sliderComponent.querySelector('[data-c-athlete-voices-thumbs]');

    if (!slider || !thumbsWrapper) return;

    var thumbs = Array.from(thumbsWrapper.querySelectorAll('.c-athlete-voices__thumb'));
    if (!thumbs.length) return;

    function visibleSlides() {
      return Array.from(slider.querySelectorAll('[id^="Slide-"]')).filter(function (el) {
        return el.clientWidth > 0;
      });
    }

    function updateActiveThumb() {
      var slides = visibleSlides();
      if (!slides.length) return;

      var offset = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : slides[0].clientWidth;
      if (!offset) return;

      var index = Math.min(Math.round(slider.scrollLeft / offset), thumbs.length - 1);

      thumbs.forEach(function (thumb, i) {
        if (i === index) {
          thumb.classList.add(ACTIVE_CLASS);
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.classList.remove(ACTIVE_CLASS);
          thumb.removeAttribute('aria-current');
        }
      });
    }

    // サムネクリック → 対応スライドへスクロール
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        var slides = visibleSlides();
        if (!slides.length || !slides[i]) return;
        slider.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      });
    });

    var ticking = false;
    slider.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          requestAnimationFrame(function () {
            updateActiveThumb();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateActiveThumb).observe(slider);
    }

    updateActiveThumb();
  }

  function init() {
    document.querySelectorAll('slider-component.c-athlete-voices__slider').forEach(initThumbs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
